import {
  Paper,
  Box,
  Typography,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
} from '@mui/material';
import {
  FilterList as FilterListIcon,
  Clear as ClearIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import { filterPaper, filterHeader } from '../styles/pageStyles';

/**
 * Filtros para schedules — layout compacto, responsivo.
 */
export default function ScheduleFilters({
  searchTerm,
  onSearchChange,
  filterProfessional,
  onProfessionalChange,
  filterPlace,
  onPlaceChange,
  filterStatus,
  onStatusChange,
  professionals = [],
  places = [],
  onClearFilters,
}) {
  const hasActiveFilters = searchTerm || filterProfessional || filterPlace || filterStatus;

  const statusOptions = [
    { value: '',          label: 'Todos' },
    { value: 'Active',    label: 'Ativa' },
    { value: 'Inactive',  label: 'Inativa' },
    { value: 'Scheduled', label: 'Agendada' },
    { value: 'Expired',   label: 'Expirada' },
    { value: 'Deleted',   label: 'Excluída' },
  ];

  return (
    <Paper sx={filterPaper}>
      <Box sx={filterHeader}>
        <FilterListIcon fontSize="small" color="action" />
        <Typography variant="subtitle2" color="text.secondary" fontWeight="medium">
          Filtros
        </Typography>
        <Button
          size="small"
          startIcon={<ClearIcon />}
          onClick={onClearFilters}
          disabled={!hasActiveFilters}
          sx={{ ml: 'auto' }}
        >
          Limpar
        </Button>
      </Box>

      <Grid container spacing={1.5}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            size="small"
            label="Buscar por nome"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            InputProps={{
              startAdornment: <SearchIcon sx={{ mr: 0.5, color: 'action.active', fontSize: 18 }} />,
            }}
            placeholder="Nome da agenda..."
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Profissional</InputLabel>
            <Select
              value={filterProfessional}
              onChange={(e) => onProfessionalChange(e.target.value)}
              label="Profissional"
            >
              <MenuItem value="">Todos</MenuItem>
              {professionals.map((prof) => (
                <MenuItem key={prof.id} value={prof.id}>
                  {prof.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Local</InputLabel>
            <Select
              value={filterPlace}
              onChange={(e) => onPlaceChange(e.target.value)}
              label="Local"
            >
              <MenuItem value="">Todos</MenuItem>
              {places.map((place) => (
                <MenuItem key={place.id} value={place.id}>
                  {place.name}{place.addressCity ? ` (${place.addressCity})` : ''}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <FormControl fullWidth size="small">
            <InputLabel>Status</InputLabel>
            <Select
              value={filterStatus}
              onChange={(e) => onStatusChange(e.target.value)}
              label="Status"
            >
              {statusOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Paper>
  );
}

